// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__ZSwel","school":"ComboboxCoso_school__GILSD","logo":"ComboboxCoso_logo__bAw--","name":"ComboboxCoso_name__YPK4B"};